import React, { FC } from 'react';
import { useQuery } from '@apollo/client';

import GET_AZSAPP_CLASSROOM_SETTINGS from 'graph/settings/azsapp/get-azsapp-classroom-settings-query';
import PageContainer from 'components/@layout/PageContainer';
import ExposeLetterBooksSetting from './ExposeLetterBooks';
import { Classroom } from 'types/schema-generated-types';

interface AzsappSettingsProps {
  classroom: Classroom;
  expanded: string | null;
  handleChangeExpanded: (panel: string | null) => () => void;
}

const ClassroomAzsappSettings: FC<AzsappSettingsProps> = ({
  classroom,
  expanded,
  handleChangeExpanded
}) => {
  const { id: classroomId } = classroom;
  const { data, loading } = useQuery(GET_AZSAPP_CLASSROOM_SETTINGS, {
    variables: {
      where: {
        classroomId: Number(classroomId)
      }
    }
  });

  return (
    <PageContainer loading={loading}>
      <ExposeLetterBooksSetting
        classroom={classroom}
        setting={data?.azsappClassroomSettings?.accessBookAfterAssignment}
        expanded={expanded}
        handleChangeExpanded={handleChangeExpanded}
      />
    </PageContainer>
  );
};

export default ClassroomAzsappSettings;
